/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_ExerciseInputs */

const en_privacy_section_7_exercise = /** @type {(inputs: Privacy_Section_7_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To exercise any of these rights, please contact us at the email address below. We will respond to your request within 30 days.`)
};

const lv_privacy_section_7_exercise = /** @type {(inputs: Privacy_Section_7_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lai izmantotu kādu no šīm tiesībām, lūdzu, sazinieties ar mums, izmantojot zemāk norādīto e-pasta adresi. Atbildēsim uz Jūsu pieprasījumu 30 dienu laikā.`)
};

/**
* | output |
* | --- |
* | "To exercise any of these rights, please contact us at the email address below. We will respond to your request within 30 days." |
*
* @param {Privacy_Section_7_ExerciseInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_exercise = /** @type {((inputs?: Privacy_Section_7_ExerciseInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_ExerciseInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_exercise(inputs)
	return en_privacy_section_7_exercise(inputs)
});